import { userInteractionAction, ViewType } from 'owa-calendar-actions';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { getOpxHostApi, isOpxHostInitialized } from 'owa-opx';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { getHostHub, WIN32_OUTLOOK_HUB, TEAMS_HUB, HUB } from 'owa-config';
import { lazyExecuteDeepLink } from 'owa-metaos-app-bootstrap';

/**
 * Util to be used when join button is clicked
 * @param event CalendarEvent on which join is clicked
 * @param viewType ViewType of the UX
 * @param actionIfNotOpx The action to be performed if it is not OPX scenario
 */
export default function onJoinTeamsClicked(
    event: CalendarEvent,
    viewType: ViewType,
    actionIfNotOpx?: () => void
) {
    let hostHub = getHostHub();
    if (
        isHostAppFeatureEnabled('joinTeamsMeeting') &&
        ((isOpxHostInitialized() && getOpxHostApi().joinTeamsMeeting) ||
            hostHub == TEAMS_HUB ||
            hostHub == WIN32_OUTLOOK_HUB ||
            hostHub == HUB)
    ) {
        // If it's hosted in opx, then call the teams join API if possible
        if (isOpxHostInitialized() && getOpxHostApi().joinTeamsMeeting) {
            getOpxHostApi().joinTeamsMeeting(event);
        } else {
            // It is hosted in a MetaOS hub, call the metaOS join API
            lazyExecuteDeepLink.importAndExecute(event.OnlineMeetingJoinUrl);
        }
    } else {
        if (actionIfNotOpx) {
            actionIfNotOpx();
        }
    }

    userInteractionAction('JoinOnlineMeeting', viewType, event.IsOrganizer, event.IsMeeting, [
        event.OnlineMeetingProvider,
    ]);
}
